import React from 'react';
import { FadeIn } from './FadeIn';
import { Button } from './Button';
export function HeroSection() {
  return <section className="relative min-h-[90vh] flex items-center justify-center overflow-hidden px-6 py-20" data-id="element-117">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0" data-id="element-118">
        <img src="https://images.unsplash.com/photo-1511895426328-dc8714191300?w=1920&q=80" alt="Familia hispana abrazándose al atardecer" className="w-full h-full object-cover object-center" data-id="element-119" />
        <div className="absolute inset-0 bg-black/50" data-id="element-120"></div>
        {/* Gradient to blend into the next section */}
        <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-brand-black to-transparent" data-id="element-121"></div>
      </div>

      <div className="relative z-10 max-w-[900px] mx-auto text-center mt-10" data-id="element-122">
        <FadeIn data-id="element-123">
          <h1 className="text-[36px] md:text-[52px] font-bold text-white mb-6 leading-tight drop-shadow-lg" data-id="element-124">
            Cuando Te Vayas... <br data-id="element-125" />
            ¿Quién Pagará Tu Funeral?
          </h1>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-126">
          <p className="text-[20px] md:text-[24px] text-white/90 max-w-3xl mx-auto leading-relaxed mb-10 drop-shadow-md" data-id="element-127">
            Protege a tu familia de una deuda devastadora... sin exámenes
            médicos, sin complicaciones y desde tan solo{' '}
            <strong className="text-white font-bold" data-id="element-128">$1 al día</strong>.
          </p>
        </FadeIn>

        <FadeIn delay={0.4} data-id="element-129">
          <Button onClick={() => document.getElementById('formulario')?.scrollIntoView({
          behavior: 'smooth'
        })} data-id="element-130">
            QUIERO PROTEGER A MI FAMILIA HOY
          </Button>
        </FadeIn>
      </div>
    </section>;
}